/* stylelint-disable */
import { css, SerializedStyles } from '@emotion/react';

export const intercomChatStyle = (isCasino: boolean): SerializedStyles => css`
    .intercom-lightweight-app-launcher,
    .intercom-namespace .intercom-app > div:has(> .intercom-launcher-frame) {
        bottom: ${isCasino ? '65px !important' : '100px !important'};
        right: 20px !important;
        z-index: 1 !important;

        @media(min-width: 1024px){
            bottom: 20px !important;
            z-index: 11 !important;
        }
    }

    .intercom-namespace iframe[name='intercom-notification-stack-frame'] {
        bottom: ${isCasino ? '124px !important' : '164px !important'};
        right: 20px !important;
        z-index: 1 !important;

        @media(min-width: 1024px){
            bottom: 84px !important;
            z-index: 11 !important;
        }
    }

    .intercom-launcher-discovery-frame {
        right: 88px !important;

        @media(min-width: 1024px){
            right: 20px !important;
        }
    }

    .intercom-lightweight-app {
        z-index: 1 !important;

        @media(min-width: 1024px){
            z-index: 11 !important;
        }
    }

    .intercom-messenger-frame  {
        bottom: ${isCasino ? '124px !important' : '164px !important'};
        @media(min-width: 1024px){
            bottom: 84px !important;
        }
    }
`;
